export default function onlyNumberHandleChange(value) {
  let result = Array.from(value)
    .filter(char => char.charCodeAt(0) >= 48 && char.charCodeAt(0) <= 57)
    .join('');

  return result;
}
